import React, {useEffect, useState} from 'react';
import { Layout, Row, Col, Pagination} from 'antd';
import { Descriptions } from 'antd';
import axios from "axios";
import AxiosRequest from "../../helpers/AxiosRequest";
import MsgsTable from "../../components/msgsTable/MsgsTable";
import {Link} from "react-router-dom";
import DeleteMsg from "../../components/msgsTable/deleteMsg";
import UsersBan from "../../components/usersTable/usersBan";

const { Content } = Layout;

const SingleUserPage = (props) => {

    const [user, setUser] = useState({});
    const [userData, setUserData] = useState({});
    const [msgs, setMsgs] = useState(null);
    const [total, setTotal] = useState(0);
    const [per, setPer] = useState(10);
    const [filters, setFilters] = useState({imba_id: props.match.params.imba_id, per_page: 10});
    const columns = [
        {
            title: 'id',
            dataIndex: 'id',
            key: 'id',
            render: text => <a>{text}</a>,
        },
        {
            title: 'User name',
            dataIndex: 'user',
            key: 'userName',
            render: user => <Link to={{
                pathname: `/${props.match.params.imba_id}/user/${user.remote_user_id}`
            }}>{user.login!='NULL' ? user.login: user.remote_user_id}</Link>,
        },
        {
            title: 'Room name',
            dataIndex: 'room',
            key: 'roomName',
            render: room => (room!=null) ? <Link to={{
                pathname:  `/${props.match.params.imba_id}/room/${room.id}`,
            }}>{room.name}</Link> : 'Technical support',
        },
        {
            title: 'Message',
            dataIndex: 'message',
            key: 'messageText',
            render: text => <p>{text}</p>
        },
        {
            title: 'Actions',
            key: 'actions',
            dataIndex: 'user',
            render: (text, record) => (
                <>
                    <DeleteMsg msg={record} imba_id={props.match.params.imba_id}/>
                    <UsersBan record={text} imba_id={props.match.params.imba_id}/>
                </>
                
            )
        }
    ];

    useEffect(() => {
        (async () => {
            setTimeout(()=>{
                if(document.querySelector(".ant-spin-dot.ant-spin-dot-spin")!=null) {
                    //window.location.reload()
                }
            },15000)
            AxiosRequest("imba_single_user", {
                id: props.match.params.id,
                imba_id: props.match.params.imba_id
            })
                .then((data) => {
                    setUser(data)
                    setUserData(data.api_info[0])
                })
                .catch((error) =>{
                    console.log('error1',error)
                    //window.location.reload()
                    //document.querySelector(".ant-spin-dot.ant-spin-dot-spin").remove(); 
                   // window.location.href = `#/${props.match.params.imba_id}/signIn`
                });
        })();
    }, []);

    useEffect(() => {
        if (user.id)
        {
            let params = {
                user_id: user.id,
                imba_id: props.match.params.imba_id
            }
            AxiosRequest('imba_msgs_get', {...filters, user_id: user.id})
                .then((response) => {
                    console.log(response.data)
                    setMsgs(response.data)
                    setTotal(response.total)
                    setPer(response.per_page)
                })
        }
    }, [user,filters])
    const UserData = () => (
            <Descriptions title="User Info" layout="vertical">
                <Descriptions.Item label="UserName">{userData.name}</Descriptions.Item>
                <Descriptions.Item label="E-Mail">{userData.user_mail}</Descriptions.Item>
                <Descriptions.Item label="Chat Role">{userData.chat_role}</Descriptions.Item>
            </Descriptions>
    )
    function onChangePage(page, size) {
        setFilters({
            ...filters,  //take existing key-value pairs and use them in our new state,
            page: page   //define new key-value pair with new uuid and [].
        })
    }
    function onChangeSize(current, size) {
        setFilters({
            ...filters.per_page = size,  //take existing key-value pairs and use them in our new state,
        })
    }
    return(
        <div>
            <Content style={{ padding: '50px 150px' }}>
                <div className="site-layout-content">
                    <UserData />
                </div>
            </Content>
            <div>
                <MsgsTable  columns={columns} dataSource={msgs}/>
            </div>
            <Pagination
                className={'table-pagination'}
                showSizeChanger
                onShowSizeChange={onChangeSize}
                defaultCurrent={1}
                PageSize={per}
                total={total}
                onChange={onChangePage}
            />
        </div>
    )
}

export default SingleUserPage;